<div class="container">
  <div class="container-inventory">
    <div class="header">
      <h1 class="title">{{ 'GENERAL_INFORMATION' | translate }}</h1>
    </div>

    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="form-card">
      <div class="label">
        <div class="label-group">
          <i class="feather" data-feather="info"></i>
          <strong>{{ 'GENERAL_INFORMATION' | translate }}</strong>
        </div>
        <div class="label-edit">
          <a class="edit-link" [ngClass]="{'visually-hidden': isEditingGeneral == true}" (click)="switchEditingAll()">
            <i class="feather" data-feather="edit"></i>
          </a>

          <a class="edit-link" [ngClass]="{'visually-hidden': isEditingGeneral == false}"
            (click)="switchCancelEditingAll()">
            <i class="feather-cancel" data-feather="x-circle"></i>
          </a>
        </div>
      </div>
      <div class="loading" *ngIf="loadingInfo">
        <div class="spinner-border" role="status"></div>
      </div>
      <div class="info-container row" *ngIf="!loadingInfo">
        <div class="data-container col-md-4" *ngIf="!isEditingGeneral">
          <label class="data-label" for="">{{ 'STORE_NAME' | translate }}</label>
          <output class="data-output">{{ shopInfo.shopName }}</output>
        </div>
        <div class="editing data-container form-group col-md-4" *ngIf="isEditingGeneral">
          <label class="data-label" for="">{{ 'STORE_NAME' | translate }}</label>
          <input [(ngModel)]="shopInfo.shopName" class="form-control" type="text" value="{{ shopInfo.shopName }}" />
        </div>
        <div class="data-container col-md-4" *ngIf="!isEditingGeneral">
          <label class="data-label" for="">{{'CURRENCY' | translate}}</label>
          <output class="data-output">{{ currentCurrencyCode }}</output>
        </div>
        <div class="editing data-container form-group col-md-4" *ngIf="isEditingGeneral">
          <label class="data-label" for="">{{'CURRENCY' | translate}}</label>
          <!-- <input class="form-control" type="text" value="{{ shopTheme[0].currencyCode }}" /> -->
          <select class="form-control" (change)="changeCurrency($event)">
            <option *ngFor="let currency of currencies" value="{{currency.currencyId}}"
              [selected]="shopInfo.currencyId == currency.currencyId">({{currency.currencyCode}}) -
              {{currency.currencyName}}</option>
          </select>
        </div>
        <div class="data-container col-md-4" *ngIf="!isEditingGeneral">
          <label class="data-label" for="">{{'EMAIL' | translate}}</label>
          <output class="data-output" style="white-space: pre-line;">{{ shopInfo.shopMail?.join('\n') }}</output>
        </div>
        <div class="editing data-container form-group col-md-4" *ngIf="isEditingGeneral">
          <label class="data-label">{{ 'EMAIL' | translate }}</label>

          <div *ngFor="let email of shopInfo.shopMail; let i = index; trackBy: trackByIndex"
            class="d-flex mb-2 align-items-center gap-2">
            <input class="form-control flex-grow-1" [(ngModel)]="shopInfo.shopMail[i]" [name]="'email' + i"
              placeholder="{{ 'EMAIL' | translate }}" />
            <div class="d-flex align-items-center" style="width: 32px; justify-content: center;">
              <button *ngIf="i === 0 && shopInfo.shopMail.length < 2" type="button"
                class="btn btn-icon border-0 bg-transparent p-0" (click)="addEmail()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024">
                  <path fill="#ea803f"
                    d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0m0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01M736 480H544V288c0-17.664-14.336-32-32-32s-32 14.336-32 32v192H288c-17.664 0-32 14.336-32 32s14.336 32 32 32h192v192c0 17.664 14.336 32 32 32s32-14.336 32-32V544h192c17.664 0 32-14.336 32-32s-14.336-32-32-32" />
                </svg>
              </button>
              <button *ngIf="i > 0" type="button" class="btn btn-icon border-0 bg-transparent p-0"
                (click)="removeEmail(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                  <path fill="#e11d48"
                    d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12l1.41 1.41L13.41 14l2.12 2.12l-1.41 1.41L12 15.41l-2.12 2.12l-1.41-1.41L10.59 14zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="label mt-4">
          <div class="label-group">
            <i class="feather" data-feather="map-pin"></i>
            <strong>{{ 'LOCATION' | translate }}</strong>
          </div>
        </div>
        <div class="loading" *ngIf="loadingLocation">
          <div class="spinner-border" role="status"></div>
        </div>
        <div class="info-container row" *ngIf="!loadingLocation">

          <!-- Country -->
          <div class="data-container col-md-4">
            <label class="data-label" for="">{{ 'COUNTRY' | translate }}</label>
            <ng-container *ngIf="!isEditingLocation">
              <label>{{ getCountryName() }}</label>
            </ng-container>
            <ng-container *ngIf="isEditingLocation">
              <select class="form-control" (change)="changeCountry($event)">
                <option value="0"></option>
                <option *ngFor="let country of countries" [value]="country.countryId"
                  [selected]="shopInfo.countryId == country.countryId">
                  {{country.countryName}}
                </option>
              </select>
            </ng-container>
          </div>

          <!-- Province -->
          <div class="data-container col-md-4">
            <label class="data-label" for="">{{ 'PROVINCE' | translate }}</label>
            <ng-container *ngIf="!isEditingLocation">
              <label>{{ getProvinceName() }}</label>
            </ng-container>
            <ng-container *ngIf="isEditingLocation">
              <select class="form-control" (change)="changeGeoLocation1($event)">
                <option value="0">{{'SELECT_OPTION' | translate}}</option>
                <option *ngFor="let geoloc1 of geoLocation1" [value]="geoloc1.id"
                  [selected]="shopInfo.shopGeoLocation1Id == geoloc1.id">
                  {{geoloc1.name }}
                </option>
              </select>
            </ng-container>
          </div>

          <!-- Canton -->
          <div class="data-container col-md-4">
            <label class="data-label" for="">{{ 'CANTON' | translate }}</label>
            <ng-container *ngIf="!isEditingLocation">
              <label>{{ getCantonName() }}</label>
            </ng-container>
            <ng-container *ngIf="isEditingLocation">
              <select class="form-control" (change)="changeGeoLocation2($event)">
                <option value="0">{{'SELECT_OPTION' | translate}}</option>
                <option *ngFor="let geoloc2 of geoLocation2" [value]="geoloc2.id"
                  [selected]="shopInfo.shopGeoLocation2Id == geoloc2.id">
                  {{geoloc2.name}}
                </option>
              </select>
            </ng-container>
          </div>

          <!-- District -->
          <div class="data-container col-md-4">
            <label class="data-label" for="">{{ 'DISTRICT' | translate }}</label>
            <ng-container *ngIf="!isEditingLocation">
              <label>{{ getDistrictName() }}</label>
            </ng-container>
            <ng-container *ngIf="isEditingLocation">
              <select class="form-control" (change)="changeGeoLocation3($event)">
                <option value="0">{{'SELECT_OPTION' | translate}}</option>
                <option *ngFor="let geoloc3 of geoLocation3" [value]="geoloc3.id"
                  [selected]="shopInfo.shopGeoLocation3Id == geoloc3.id">
                  {{geoloc3.name}}
                </option>
              </select>
            </ng-container>
          </div>

          <div class="data-container col-md-8">
            <label class="data-label" for="">{{ 'ADDRESS' | translate }}</label>
            <output class="data-output" *ngIf="!isEditingGeneral">{{ shopInfo.shopAddress }}</output>
            <textarea class="form-control" *ngIf="isEditingGeneral" [(ngModel)]="shopInfo.shopAddress"
              rows="3"></textarea>
          </div>
        </div>
        <div class="info-container flex-grow-1 row justify-content-between">
          <div class="data-container col-md-3">
            <div *ngIf="!loading" class="form-group-container">
              <div class="label">
                <div class="label-group">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      color="#ea803f">
                      <path
                        d="M2 8.57c0-1.197.482-1.93 1.48-2.486l4.11-2.287C9.743 2.6 10.82 2 12 2s2.257.6 4.41 1.797l4.11 2.287C21.517 6.64 22 7.373 22 8.57c0 .324 0 .487-.035.62c-.186.7-.821.811-1.434.811H3.469c-.613 0-1.247-.11-1.434-.811C2 9.056 2 8.893 2 8.569M4 10v8.5M8 10v8.5m3 0H5a3 3 0 0 0-3 3a.5.5 0 0 0 .5.5H11m10.5-7.5l-7 7" />
                      <circle cx="15.25" cy="15.25" r=".75" />
                      <circle cx="20.75" cy="20.75" r=".75" />
                    </g>
                  </svg>
                  <strong>{{'TAX' | translate}}</strong>
                </div>
              </div>
              <div class="info-container">
                <div class="data-container">
                  <label class="data-label" for="">{{'TYPE_TAX' | translate}}</label>
                  <output class="data-output" *ngIf="!isEditingGeneral">{{ getTaxName() }}</output>
                  <select class="form-select" *ngIf="isEditingGeneral" [(ngModel)]="taxId" (change)="changeTax($event)">
                    <option *ngFor="let tax of taxes" [value]="tax.taxId">
                      {{ tax.taxName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="login-required-switch col-md-3">
            <div class="label-group">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M9.375 7.875a2.625 2.625 0 1 0 5.25 0a2.625 2.625 0 0 0-5.25 0M7.5 15.75a4.5 4.5 0 1 1 9 0"/><path d="M3 2.25h18s1.5 0 1.5 1.5v13.5s0 1.5-1.5 1.5H3s-1.5 0-1.5-1.5V3.75s0-1.5 1.5-1.5m9 16.5v3m-7.5 0h15"/></g></svg>
              <strong>{{ 'LOGIN_REQUIRED' | translate }}</strong>
            </div>
            <mat-slide-toggle
              [(ngModel)]="isLoginRequired"
              (change)="updateLoginRequirement($event)"
              class="switch">
            </mat-slide-toggle>

            <small class="switch-description d-block mt-1">
              {{ isLoginRequired
                ? ('LOGIN_REQUIRED_ENABLED' | translate)
                : ('LOGIN_REQUIRED_DISABLED' | translate)
              }}
            </small>

            <div
              *ngIf="showLoginFeedback === 'success'"
              class="alert alert-success p-1 mt-2 small text-center">
              ✅ {{ 'CHANGES_SAVED' | translate }}
            </div>

            <div
              *ngIf="showLoginFeedback === 'error'"
              class="alert alert-danger p-1 mt-2 small text-center">
              ⚠️ {{ 'ERROR' | translate }}
            </div>
          </div>
          <div class="login-required-switch col-md-3">
            <div class="label-group">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                  <path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12"/>
                  <path d="M13 2.05S16 6 16 12s-3 9.95-3 9.95m-2 0S8 18 8 12s3-9.95 3-9.95M2.63 15.5h18.74m-18.74-7h18.74"/>
                </g>
              </svg>
              <strong>{{ 'PREFERRED_LANGUAGE' | translate }}</strong>
            </div>

            <div class="switch-inline-labels mt-2">
              <span [class.active]="!isPreferredLanguageEnglish">{{ 'SPANISH' | translate }}</span>
              <mat-slide-toggle
                [(ngModel)]="isPreferredLanguageEnglish"
                (change)="updatePreferredLanguage($event)"
                class="switch">
              </mat-slide-toggle>
              <span [class.active]="isPreferredLanguageEnglish">{{ 'ENGLISH' | translate }}</span>
            </div>

            <small class="switch-description d-block mt-1">
              {{ isPreferredLanguageEnglish
                ? ('PREFERRED_LANGUAGE_ENGLISH' | translate)
                : ('PREFERRED_LANGUAGE_SPANISH' | translate)
              }}
            </small>

            <div
              *ngIf="showLanguageFeedback === 'success'"
              class="alert alert-success p-1 mt-2 small text-center">
              ✅ {{ 'CHANGES_SAVED' | translate }}
            </div>

            <div
              *ngIf="showLanguageFeedback === 'error'"
              class="alert alert-danger p-1 mt-2 small text-center">
              ⚠️ {{ 'ERROR' | translate }}
            </div>
          </div>
          <div class="login-required-switch login-redirect-setting col-md-3">
            <div class="label-group">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                  <path d="M5 12h14" />
                  <path d="m13 6 6 6-6 6" />
                </g>
              </svg>
              <strong>{{ 'LOGIN_REDIRECT' | translate }}</strong>
            </div>

            <div class="login-redirect-options">
              <label [class.selected]="loginRedirect === 'home'">
                <input type="radio" name="loginRedirect" value="home" [(ngModel)]="loginRedirect" (ngModelChange)="updateShopInfo()" />
                <span class="radio-indicator" aria-hidden="true"></span>
                {{ 'START' | translate }}
              </label>
              <label [class.selected]="loginRedirect === 'dashboard'">
                <input type="radio" name="loginRedirect" value="dashboard" [(ngModel)]="loginRedirect" (ngModelChange)="updateShopInfo()" />
                <span class="radio-indicator" aria-hidden="true"></span>
                {{ 'DASHBOARD' | translate }}
              </label>
            </div>

            <small class="switch-description d-block mt-1">
              {{ 'LOGIN_REDIRECT_HELP' | translate }}
            </small>
          </div>
      </div>
    </div>

    <div class="button-container">
      <button type="button" class="primary-btn submit-btn" *ngIf="isEditingGeneral || isEditingLocation"
        (click)="updateShopInfo()">
        {{'SAVE' | translate}}
      </button>
    </div>
  </div>

  <div class="form-card">
    <div class="label">
      <div class="label-group">
        <i class="feather" data-feather="smartphone"></i>
        <strong>{{ 'SOCIAL_NETWORKS' | translate }}</strong>
      </div>
      <div class="label-edit">
        <a class="edit-link" [ngClass]="{'visually-hidden': isEditingSocial == true}" (click)="switchEditingSocial()">
          <i class="feather" data-feather="edit"></i>
        </a>
        <a class="primary-btn edit-link" *ngIf="isEditingSocial" (click)="updateShopSocialMedia()">{{'SAVE' |
          translate}}</a>
      </div>
    </div>
    <div class="loading" *ngIf="loadingSocial">
      <div class="spinner-border" role="status"></div>
    </div>
    <div class="info-container row" *ngIf="!loadingSocial">
      <div class="col-md-6" *ngFor="let socialNet of shopSocialMedia">
        <div class="data-container" *ngIf="!isEditingSocial">
          <div class="social-icon">
            <img
              *ngIf="getSocialMediaIconPath(socialNet.socialMediaName) as iconPath"
              [src]="iconPath"
              [alt]="socialNet.socialMediaName"
              class="icon-svg" />
            <label class="data-label">{{socialNet.socialMediaName}}</label>
          </div>
          <output class="data-output">{{socialNet.socialMediaURL}}</output>
        </div>
        <div class="editing data-container form-group" *ngIf="isEditingSocial">
          <label class="data-label">{{socialNet.socialMediaName}}</label>
          <input [(ngModel)]="socialNet.socialMediaURL" class="form-control" type="text" />
          <div *ngIf="getSocialMediaExample(socialNet.socialMediaName) as example" class="form-text col-md-3">Ej:
            {{example}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<div class="modal product-modal" id="productModal" tabindex="-1">
  <div class="modal-dialog product-modal-dialog" role="document">
    <div class="modal-content product-modal-content">
      <div class="modal-body product-modal-body">
        <div class="loading">
          <div class="spinner-border" role="status"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal shop-data-confirm-modal fade" id="successShopDataModal" tabindex="-1">
  <div class="modal-dialog shop-data-modal-dialog" role="document">
    <div class="modal-content shop-data-modal-content">
      <div class="modal-body shop-data-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{'CHANGES_SAVED_SUCCESS' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
